import { useMemo } from 'react';
import { formatToCurrency } from 'utils';
import { CalculationsValues } from '../useCalculations';

export interface MonthlyHook {
  valid: boolean;
  label: string;
}

export default function useMonthly(values: CalculationsValues): MonthlyHook {
  const valid = useMemo(() => values.valid, [values]);

  const label = useMemo(() => {
    if (values.valid) return '';
    const { total, rate } = values;
    const {
      min_job_value: minJobValue = 0,
      max_job_value: maxJobValue = 500000,
    } = rate;
    if (total <= minJobValue) return `Minimum ${formatToCurrency(minJobValue)}`;
    if (total >= maxJobValue) return `Maximum ${formatToCurrency(maxJobValue)}`;
    return 'Change amount';
  }, [values]);

  return {
    valid,
    label,
  };
}
